import React from 'react'
import ReactDOM from 'react-dom/client'
import Site from './components/Site'

ReactDOM.createRoot(document.getElementById('root')!).render(<Site />)
